import React from "react";
import { useOutletContext } from "react-router-dom";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { scheduleRows, scheduleSubtitle } from "../../../utils/tutorDetail";
import { tokens } from "../../../utils/figmaTokens";
import { TableCard } from "../../../components/kit/SectionCard";

// The week the tutor set in the app (047 D51): each day's hours in the tutor's own time zone,
// Monday first, straight from the users document — no read of its own.
const ScheduleTab = () => {
  const { tutor } = useOutletContext();
  return (
    <TableCard title="Schedule" subtitle={scheduleSubtitle(tutor)}>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Day</TableCell>
              <TableCell>Hours</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {scheduleRows(tutor.availability).map((row) => (
              <TableRow key={row.day}>
                <TableCell sx={{ fontWeight: 500, width: 200 }}>{row.day}</TableCell>
                <TableCell sx={{ color: row.on ? tokens.text.primary : tokens.text.tertiary }}>{row.hours}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </TableCard>
  );
};

export default ScheduleTab;
